import hasPermi from "./permission/hasPermi";
import integerOnly from "./integerOnly";

export default function directive(app) {
  app.directive("hasPermi", hasPermi);
  app.directive("integerOnly", integerOnly);
}
